import React, { FC } from 'react'
import { Typography } from 'antd'
import { ResponsiveContainer, ResponsiveContainerProps } from 'recharts'

export interface RChartContainerProps extends ResponsiveContainerProps {
  title?: string
}

const RChartContainer: FC<RChartContainerProps> = ({
  height = '100%',
  width = '100%',
  minHeight = 100,
  title = '',
  children,
  ...reChartsContainerProps
}) => {
  return (
    <>
      {title && (
        <Typography.Title className='primary' level={4}>
          {title}
        </Typography.Title>
      )}
      <ResponsiveContainer
        height={height}
        width={width}
        minHeight={minHeight}
        {...reChartsContainerProps}
      >
        {children}
      </ResponsiveContainer>
    </>
  )
}

export default RChartContainer
